import React from 'react'
import { Switch, FormControlLabel, Button } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'

function ConfiguracionDestare (props) {
  const { rolAutorizado, modoBarreras, pesadoAuto, equilibrio, enclavamientoBarreras } = props

  return (
    <div className='container-switches-destare'>
      { (rolAutorizado) && <div>
        <FormControlLabel
          control={<Switch
            color='primary'
            name='pesadoAuto'
            onChange={props.updateModoPesado}
            checked={pesadoAuto}
          />
          }
          label='Pesaje automatico'
        />
      </div>
      }
      <div>
        <FormControlLabel
          control={<Switch
            color='primary'
            name='cicloBarreras'
            onChange={props.updateCicloBarreras}
            checked={modoBarreras === 'auto'}
          />
          }
          label='Ciclo de barreras automatico'
        />
      </div>
      <div>
        <FormControlLabel
          control={<Switch
            color='primary'
            name='forzarBarreras'
            onChange={props.updateForzarBarreras}
            checked={props.forzarBarreras === 'si'}
          />
          }
          label='Forzar barreras abiertas'
        />
      </div>

      { (rolAutorizado) && <div>
        <FormControlLabel
          control={<Switch
            color='primary'
            name='enclavamiento'
            onChange={props.updateEnclavamiento}
            checked={equilibrio === 1}
          />
          }
          label='Enclavamiento / Equilibrio'
        />
      </div>
      }

      <div>
        <FormControlLabel
          control={<Switch
            color='primary'
            name='enclavamientoBarrerasDestare'
            onChange={props.updateEnclavamientoBarreras}
            checked={enclavamientoBarreras === 1}
            disabled={!rolAutorizado}
          />
          }
          label='Enclavamiento de barreras'
        />
      </div>

      { (rolAutorizado) &&
      <Button
        className='btn-accion-destare btn btn-dialog-configuracion '
        onClick={props.openDialogConfiguracion}
        variant='contained'
        style={{ backgroundColor: COLORES.grey.dark, color: '#ffffff' }}
      >
                    Más configuraciones
      </Button>
      }
    </div>
  )
}

export default ConfiguracionDestare
